class EofyTier extends HTMLElement {
  connectedCallback() {
    if (this.dataset.eofyTierInit === 'true') return;
    this.dataset.eofyTierInit = 'true';
    this.initModuleImpression();
  }

  disconnectedCallback() {
    if (this.moduleImpressionObserver) {
      this.moduleImpressionObserver.disconnect();
      this.moduleImpressionObserver = null;
    }
  }

  isInView() {
    const rect = this.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const visible = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
    return visible >= rect.height * 0.33;
  }

  pushModuleImpressionGa4() {
    if (this.dataset.eofyTierModuleImpression === 'true') return;
    this.dataset.eofyTierModuleImpression = 'true';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'module_impression',
      event_parameters: {
        module: 'discount',
      },
    });
  }

  tryPushModuleImpressionGa4() {
    if (this.dataset.eofyTierModuleImpression === 'true') return false;
    if (!this.isInView()) return false;
    this.pushModuleImpressionGa4();
    return true;
  }

  initModuleImpression() {
    if (!('IntersectionObserver' in window)) {
      this.tryPushModuleImpressionGa4();
      return;
    }

    this.moduleImpressionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          if (this.tryPushModuleImpressionGa4()) {
            this.moduleImpressionObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.33 }
    );

    this.moduleImpressionObserver.observe(this);
    this.tryPushModuleImpressionGa4();
  }
}

if (!customElements.get('eofy-tier')) {
  customElements.define('eofy-tier', EofyTier);
}
